<template>
  <div>
    <v-list subheader two-line>
      <v-card
        class="blue"
        flat
        :style="{ borderRadius: '0px', padding: '15px' }"
      >
        <b-row>
          <b-col cols="4">
            <AutoBusca
              id="cliente"
              item_id="id"
              item_text="nome"
              item_campos="cli.id as id, cli.id|| ' - ' ||cli.nome || ' - ' || cli.cnpj || ' ('||TRIM(cid.nome)||'/'||cid.uf||')' as nome"
              item_busca="cli.id|| '-' || TRIM(UPPER(cli.nome))|| '-' || TRIM(UPPER(cli.cnpj)) "
              item_left="LEFT JOIN cidade cid ON cid.codcid=cli.codcid"
              tabela="cliente cli"
              :value="filtro_id_cli"
              @getID="getID"
              :label="'Digite o cliente'"
              :rdark="true"
            />
          </b-col>
          <b-col cols="2">
            <v-btn x-large @click="NovoCliente">
              <v-icon>mdi-plus</v-icon>
              Novo
            </v-btn>
          </b-col>
        </b-row>
      </v-card>

      <v-tabs v-model="tab" background-color="blue" dark>
        <v-tab v-for="item in items" :key="item.tab">
          {{ item.tab }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <div class="painelContainer">
            <b-row>
              <b-col cols="5">
                <v-text-field
                  label="Nome fantasia"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.nome"
                  :value="cliente.nome"
                  hide-details="auto"
                ></v-text-field>
              </b-col>
              <b-col cols="7">
                <v-text-field
                  label="Razão Social"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.razao"
                  :value="cliente.razao"
                  hide-details="auto"
                  maxlength="50"
                ></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field
                  label="CNPJ/CPF"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.cnpj"
                  hide-details="auto"
                  maxlength="30"
                  :value="cliente.cnpj"
                  v-mask="['###.###.###-##', '##.###.###-####/##']"
                ></v-text-field
              ></b-col>
              <b-col cols="3">
                <v-text-field
                  label="Insc. Est"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.insc_est"
                  :value="cliente.insc_est"
                  hide-details="auto"
                ></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field
                  label="Proprietário"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.proprietario"
                  :value="cliente.proprietario"
                  hide-details="auto"
                ></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field
                  label="CPF"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.cpf"
                  :value="cliente.cpf"
                  hide-details="auto"
                  maxlength="30"
                  v-mask="['###.###.###-##']"
                ></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field
                  label="CEP"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.cep"
                  hide-details="auto"
                  maxlength="10"
                  :value="cliente.cep"
                  v-mask="['#####-###']"
                ></v-text-field>
              </b-col>
              <b-col cols="7">
                <v-text-field
                  label="Rua/Avenida/Logradouro"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.endereco"
                  :value="cliente.endereco"
                  hide-details="auto"
                ></v-text-field>
              </b-col>
              <b-col cols="2">
                <v-text-field
                  label="Número"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.numero"
                  :value="cliente.numero"
                  hide-details="auto"
                ></v-text-field
              ></b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field
                  label="Bairro"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.bairro"
                  :value="cliente.bairro"
                  hide-details="auto"
                ></v-text-field
              ></b-col>
              <b-col cols="3">
                <v-text-field
                  label="Complemento"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.complement"
                  :value="cliente.complement"
                  hide-details="auto"
                ></v-text-field
              ></b-col>
              <b-col cols="6"
                ><AutoBusca
                  id="cidade"
                  item_id="codcid"
                  item_text="nome"
                  item_campos="cid.codcid, TRIM(cid.nome)||'-'||cid.uf as nome"
                  item_busca="cid.codcid::text|| '-' || TRIM(UPPER(cid.nome)) "
                  item_left=""
                  tabela="cidade cid"
                  :value="cliente.id_cidade"
                  @getID="getID"
                  :label="'Digite a cidade'"
                  :rdark="false"
              /></b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field
                  label="Fone"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.fone"
                  hide-details="auto"
                  maxlength="15"
                  :value="cliente.fone"
                  v-mask="['(##)####-####', '(##)#####-####']"
                ></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field
                  label="Fone 2"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.fone2"
                  hide-details="auto"
                  maxlength="15"
                  :value="cliente.fone2"
                  v-mask="['(##)####-####', '(##)#####-####']"
                ></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field
                  label="E-Mail"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.email"
                  :value="cliente.email"
                  hide-details="auto"
                ></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field
                  label="E-Mail Cobrança"
                  placeholder="Não informado"
                  outlined
                  v-model="cliente.email_cobranca"
                  :value="cliente.email_cobranca"
                  hide-details="auto"
                ></v-text-field>
              </b-col>
            </b-row>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-list>

    <b-container fluid>
      <b-row>
        <b-col cols="4">
          <v-btn x-large dark color="green" @click="SalvarCliente">
            <v-icon>mdi-account-check</v-icon>
            Salvar
          </v-btn>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Vue from "vue";
import AutoBusca from "../components/AutoBusca.vue";
//import InputNumeric from "../components/InputNumeric.vue";
import Cliente from "../domain/Cliente";
import _Enum from "../obj/Enum";
import { mapGetters } from "vuex";

export default {
  components: {
    AutoBusca,
    //  InputNumeric,
  },
  data: () => ({
    Enum: _Enum,
    cliente: {},
    contrato: {},
    filtro_id_cli: "",
    items: [{ tab: "Cliente" }, { tab: "Contrato" }],
    tab: 0,
    oper: "N",
    sigad: {
      nfe: false,
      nfce: false,
      nfse: false,
      licenca: false,
      emitidas: "",
    },
    disable_contrato: true,
    modal_sigad: false,
    lblRetornoSigad: "",
  }),
  computed: {
    ...mapGetters("Usuarios", ["getUsuario"]),
    getUser: function () {
      return this.getUsuario();
    },
  },
  created() {
    if (this.getUser.nivel > 1) {
      this.$router.replace({ name: "restrito" });
    }
  },

  mounted() {
    this.NovoCliente();
  },

  methods: {
    getID(val) {
      if (val.id == "cliente") {
        if (val.value != null && val.value != "") {
          this.filtro_id_cli = val.value;
          this.buscaCliente(val.value);
        } else {
          this.NovoCliente();
        }
      }

      if (val.id == "contratos") {
        if (val.value != null && val.value != "") {
          this.contrato.cod_contrato = val.value;
          this.buscaContrato(val.value);
        } else {
          this.NovoContrato();
        }
      }

      if (val.id == "cidade") {
        if (val.value != null && val.value != "") {
          this.cliente.id_cidade = val.value;
        }
      }

      if (val.id == "bancos") {
        if (val.value != null && val.value != "") {
          this.contrato.codbco = val.value;
        }
      }
    },

    getNumeric(val) {
      if (val.id == "valor") {
        this.contrato.valor = val.value;
      } else if (val.id == "valor_des") {
        this.contrato.valor_des = val.value;
      } else if (val.id == "valor_acr") {
        this.contrato.valor_acr = val.value;
      } else if (val.id == "valor_hora") {
        this.contrato.vlr_hor = val.value;
      } else if (val.id == "valor_sig") {
        this.contrato.valor_sig = val.value;
      } else if (val.id == "valor_nfceb") {
        this.contrato.valor_nfceb = val.value;
      } else if (val.id == "valor_tef") {
        this.contrato.valor_tef = val.value;
      } else if (val.id == "valor_nfce") {
        this.contrato.valor_nfce = val.value;
      } else if (val.id == "valor_nfceb2") {
        this.contrato.valor_nfceb2 = val.value;
      } else if (val.id == "dia_venc") {
        this.contrato.dia_venc = val.value;
      } else if (val.id == "valor_old") {
        this.contrato.valor_old = val.value;
      } else if (val.id == "valor_base") {
        this.contrato.valor_base = val.value;
      }
    },

    buscaCliente(id) {
      this.service = new Cliente(this.$resource);
      this.service.get(id).then(
        function (tmp) {
          if (tmp.cliente.length > 0) {
            this.cliente = tmp.cliente[0];
            this.contrato.cod_contrato = this.cliente.cod_contrato;
            if (
              this.contrato.cod_contrato == "" ||
              this.contrato.cod_contrato == null
            )
              this.NovoContrato();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },

    buscaContrato(id) {
      this.service = new Cliente(this.$resource);
      this.service.getContrato(id).then(
        function (tmp) {
          if (tmp.length > 0) {
            this.contrato = tmp[0];
            this.contrato.data_ini = Vue.fData2(this.contrato.data_ini);
            this.contrato.data_fin = Vue.fData2(this.contrato.data_fin);
            this.contrato.data_base = Vue.fData2(this.contrato.data_base);
            this.contrato.data_atu = Vue.fData2(this.contrato.data_atu);
            this.buscaStatusSig();
          } else {
            Vue.Mensagem(this, "Contrato", "Nenhum contrato encontrado");
            this.NovoContrato();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },

    buscaStatusSig() {
      var cnpj = this.cliente.cnpj;
      if (cnpj == "" || cnpj == null) return;
      var id = this.cliente.id;
      if (id == "" || id == null) return;

      this.service = new Cliente(this.$resource);
      this.service.getContratoStatus(cnpj, id).then(
        function (tmp) {
          var ret = tmp.split("|");
          if (ret[2].includes("signfe")) this.sigad.nfe = true;
          else this.sigad.nfe = false;
          if (ret[2].includes("signfce")) this.sigad.nfce = true;
          else this.sigad.nfce = false;
          if (ret[2].includes("signfse")) this.sigad.nfse = true;
          else this.sigad.nfse = false;

          /*
             LICENÇA  0-Não; 1-Sim
          */
          if (ret[1].includes("1")) this.sigad.licenca = true;
          else this.sigad.licenca = false;

          /*
             NUMEROS DE EMITIDAS
          */
          this.sigad.emitidas = ret[4]
            .toString()
            .substring(0, ret[4].length - 2);
        },
        (err) => {
          console.log(err);
        }
      );
    },

    AtivaProdutoSig(oper) {
      this.lblRetornoSigad = "";
      var cnpj = this.cliente.cnpj;
      if (cnpj == "" || cnpj == null) return;
      var fantasia = this.cliente.nome;
      if (fantasia == "" || fantasia == null) return;

      var ativo = false;
      var operacao = oper;
      if (operacao == "licenca") ativo = this.sigad.licenca;
      else if (operacao == "signfe") ativo = this.sigad.nfe;
      else if (operacao == "signfce") ativo = this.sigad.nfce;
      else if (operacao == "signfse") ativo = this.sigad.nfse;

      Vue.Loading("", "", this);
      this.service = new Cliente(this.$resource);
      this.service.AtivaProdutos(cnpj, fantasia, operacao, ativo).then(
        function (tmp) {
          if (tmp.status != 200) {
            if (operacao == "licenca") this.sigad.licenca = !this.sigad.licenca;
            else if (operacao == "signfe") this.sigad.nfe = !this.sigad.nfe;
            else if (operacao == "signfce") this.sigad.nfce = !this.sigad.nfce;
            else if (operacao == "signfse") this.sigad.nfse = !this.sigad.nfse;
          }

          this.lblRetornoSigad = tmp.bodyText;
          Vue.CloseLoading(this);
        },
        (err) => {
          this.lblRetornoSigad = err;
          console.log(err);
        }
      );
    },

    NovoCliente() {
      this.cliente = this.getTmpCliente();
      this.cliente.id = "";
      this.filtro_id_cli = null;
      this.NovoContrato();
    },

    NovoContrato() {
      this.contrato = this.getTmpContrato();
      this.contrato.cod_contrato = "";
    },

    SalvarCliente() {
      var _cli = JSON.parse(JSON.stringify(this.cliente));

      if (_cli.nome == "" || _cli.nome == null) {
        Vue.Mensagem(this, "Campo inválido", "Nome precisa ser preenchido");
        return;
      }

      if (_cli.razao == "" || _cli.razao == null) {
        Vue.Mensagem(this, "Campo inválido", "Nome precisa ser preenchido");
        return;
      }

      if (_cli.cnpj == "" || _cli.cnpj == null) {
        Vue.Mensagem(this, "Campo inválido", "CNPJ precisa ser preenchido");
        return;
      }

      if (_cli.id_cidade == "" || _cli.id_cidade == null) {
        Vue.Mensagem(this, "Campo inválido", "Cidade deve ser preenchida");
        return;
      }

      var _cnt = JSON.parse(JSON.stringify(this.contrato));
      _cnt.id_cli = _cli.nome;
      _cnt.nome = _cli.nome;

      var dados = [
        {
          cli: [_cli],
          cnt: [_cnt],
        },
      ];

      Vue.Loading("", "", this);
      this.service = new Cliente(this.$resource);
      this.service.save(dados).then(
        function (tmp) {
          if (tmp.codigo == 1)
            Vue.Mensagem(this, "OK", "Operação realizada com sucesso");
          else Vue.Mensagem(this, "Opa!", tmp.mensagem);

          Vue.CloseLoading(this);
          this.NovoCliente();
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.Mensagem(this, "Erro", err);
        }
      );
    },

    getTmpCliente() {
      return {
        id: "",
        nome: "",
        razao: "",
        cnpj: "",
        insc_est: "",
        proprietario: "",
        cpf: "",
        cep: "",
        endereco: "",
        numero: "",
        bairro: "",
        complemento: "",
        id_cidade: "",
        fone: "",
        fone2: "",
        email: "",
        email_cobranca: "",
      };
    },

    getTmpContrato() {
      this.sigad = {
        nfe: false,
        nfce: false,
        nfse: false,
        licenca: false,
        emitidas: "Não habilitado",
      };

      return {
        cod_contrato: "",
        id_cli: "",
        nome: "",
        data_ini: "",
        data_fin: "",
        valor: 0,
        valor_des: 0,
        valor_acr: 0,
        nro_fil: 0,
        dia_venc: 0,
        vlr_hor: 0,
        valor_sig: 0,
        valor_nfceb: 0,
        valor_tef: 0,
        codbco: "",
        tp_fatur: "",
        codfor: "",
        data_base: "",
        valor_base: 0,
        data_atu: "",
        valor_old: 0,
        valor_nfce: 0,
        valor_nfceb2: 0,
        obs: "",
        cartorio: false,
      };
    },
  },
};
</script>